import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import MultiUserSelectionInlineEdit from '../../../../../../MultiUserSelectionInlineEdit';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../../../constants/issue-attribute-names';
import classNames from 'classnames';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';

class DistributionListInlineEdit extends PureComponent {

  render() {
    const { issue, users, container, className, styleType, horizontalAlign } = this.props;
    const classes = classNames('DistributionListInlineEdit', className);

    return (
      <MultiUserSelectionInlineEdit
        issue={issue}
        className={classes}
        data-testid="DistributionListInlineEdit"
        attributeName={ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST}
        label={T.translate('new.distributionList')}
        users={users}
        container={container}
        styleType={styleType}
        infoMessage={horizontalAlign ? null : T.translate('info.rfiDistributionList')}
        horizontalAlign={horizontalAlign}
      />
    );
  }
}

DistributionListInlineEdit.displayName = 'DistributionListInlineEdit';


DistributionListInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  users: PropTypes.array.isRequired,
  container: PropTypes.object.isRequired,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  horizontalAlign: PropTypes.bool,
};

export default DistributionListInlineEdit;
